/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UpdateBillingAccountStatusRequest
 */
export interface UpdateBillingAccountStatusRequest {
    /**
     *
     * @type {string}
     * @memberof UpdateBillingAccountStatusRequest
     */
    status?: UpdateBillingAccountStatusRequestStatusEnum;
    /**
     *
     * @type {string}
     * @memberof UpdateBillingAccountStatusRequest
     */
    statusMessage?: string;
}

/**
 * @export
 */
export const UpdateBillingAccountStatusRequestStatusEnum = {
    Unknown: "Unknown",
    Required: "Required",
    Active: "Active",
    Suspended: "Suspended",
    Closed: "Closed",
} as const;
export type UpdateBillingAccountStatusRequestStatusEnum =
    (typeof UpdateBillingAccountStatusRequestStatusEnum)[keyof typeof UpdateBillingAccountStatusRequestStatusEnum];

/**
 * Check if a given object implements the UpdateBillingAccountStatusRequest interface.
 */
export function instanceOfUpdateBillingAccountStatusRequest(
    value: object,
): value is UpdateBillingAccountStatusRequest {
    return true;
}

export function UpdateBillingAccountStatusRequestFromJSON(
    json: any,
): UpdateBillingAccountStatusRequest {
    return UpdateBillingAccountStatusRequestFromJSONTyped(json, false);
}

export function UpdateBillingAccountStatusRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): UpdateBillingAccountStatusRequest {
    if (json == null) {
        return json;
    }
    return {
        status: json["status"] == null ? undefined : json["status"],
        statusMessage:
            json["statusMessage"] == null ? undefined : json["statusMessage"],
    };
}

export function UpdateBillingAccountStatusRequestToJSON(
    value?: UpdateBillingAccountStatusRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        status: value["status"],
        statusMessage: value["statusMessage"],
    };
}
